import { type ReactNode } from "react";

export function Tip({ text, children }: { text: string; children: ReactNode }) {
  return (
    <div className="relative inline-flex group/tip">
      {children}
      <div className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 whitespace-nowrap rounded bg-limestone-900 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover/tip:opacity-100 z-50">
        {text}
      </div>
    </div>
  );
}
